export default "/images/wrs-website.png";